import axios from "axios";
import { backendURL } from "../config";

const baseURL = axios.create({
  baseURL: backendURL,
});

export default baseURL;
